import React from "react";
import { Settings as SettingsIcon, Bell } from "lucide-react";
import Button from "../../components/common/Button";

const InstructorSettings = () => {
  return (
    <div className="cht-space-y-8 cht-animate-in cht-fade-in cht-duration-700">
      <header>
        <h1 className="cht-text-3xl cht-font-black cht-text-[#1e293b] cht-tracking-tight">Settings</h1>
        <p className="cht-text-gray-500 cht-font-medium">Manage your account notifications and teaching preferences.</p>
      </header>

      <div className="cht-grid cht-grid-cols-1 lg:cht-grid-cols-3 cht-gap-8">
        <div className="lg:cht-col-span-2 cht-space-y-6">
          <div className="cht-bg-white cht-p-8 cht-rounded-[32px] cht-border cht-border-gray-50 cht-shadow-sm">
            <h3 className="cht-text-lg cht-font-black cht-text-[#1e293b] cht-mb-6 cht-flex cht-items-center cht-gap-2">
              <Bell size={20} className="cht-text-[#3e57da]" /> Notification Preferences
            </h3>
            <div className="cht-space-y-4">
              {[
                { label: "Course Enrollments", desc: "Notify me when a new student enrolls." },
                { label: "Assignment Submissions", desc: "Notify me when a student submits work." },
                { label: "Reviews & Feedback", desc: "Notify me when a course receives a new rating." }
              ].map((item, i) => (
                <div key={i} className="cht-flex cht-items-center cht-justify-between cht-p-4 cht-bg-gray-50 cht-rounded-2xl">
                  <div>
                    <p className="cht-text-sm cht-font-bold cht-text-gray-900">{item.label}</p>
                    <p className="cht-text-xs cht-text-gray-400 cht-font-medium">{item.desc}</p>
                  </div>
                  <div className="cht-w-10 cht-h-5 cht-bg-[#3e57da] cht-rounded-full cht-relative">
                    <div className="cht-absolute cht-right-1 cht-top-1 cht-w-3 cht-h-3 cht-bg-white cht-rounded-full" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="cht-space-y-6">
          <div className="cht-bg-white cht-p-8 cht-rounded-[32px] cht-border cht-border-gray-50 cht-shadow-sm">
            <h3 className="cht-text-sm cht-font-black cht-uppercase cht-tracking-widest cht-mb-4">Teaching Preferences</h3>
            <p className="cht-text-xs cht-text-gray-400 cht-font-medium cht-mb-6">Set your global defaults for new courses and tracks.</p>
            <Button variant="outline" className="cht-w-full cht-rounded-xl">Curriculum Defaults</Button>
            <Button variant="ghost" className="cht-w-full cht-rounded-xl cht-mt-2">Language & Region</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorSettings;
